<template>
  <div id="container">
    <!-- header -->
    <Header />
    <!-- /header -->
    <div id="contents_box">
      <!-- contents -->
      <div id="contents" class="wrap_box">
        <div class="notice">
          <span class="h_title">Notice</span>
          <p v-for="(l, lindex) in main_notice_list" :key="lindex">{{ getLocalizedName(l, "content") }}</p>
        </div>

        <div class="project_list mgT30">
          <template v-for="pagegroup in pages" :key="pagegroup">
            <!-- 제목 -->
            <span class="h_title cursor">{{ pagegroup.name }}</span>

            <!-- 페이지그룹 -->
            <ul id="pages" class="pages" v-if="pagegroup.active">
              <template v-for="page in pagegroup.list" :key="page">
                <!-- <li v-if="check_perm(page.permno)"> -->
                <li v-if="true">
                  <a :href="page.link">
                    <img v-if="page.size && page.size > 0" :src="page.img" :style="'height:' + page.size + 'px;'" />
                    <img v-else :src="page.img" />
                    <p>{{ getLocalizedName(page, "name") }}
                      <span class="note_new" v-if="page.name == '개선내역' && note_new">new!</span>
                    </p>
                  </a>
                </li>
              </template>
            </ul>
          </template>
        </div>
      </div>
      <!-- //contents -->
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import axios from "axios";
import common from "../common/common.js";
import config from "../common/config.js";

export default {
  name: "Mypage",
  data() {
    return {
      pages: [
        {
          pagegroup_no: 1,
          name: "INFO",
          active: true,
          list: [
            {
              permno: [""],
              name: "던전&레이드",
              name_eng: "Dungeon&Raid",
              link: "/map",
              img: "/images/summary_enchanted_forest.png"
            },
            {
              permno: [""],
              name: "아이템 DB",
              name_eng: "Item DB",
              link: "/item",
              img: "/images/golden_sword.png"
            },
            {
              permno: [""],
              name: "직업&특성",
              name_eng: "Class&Trait",
              link: "/class",
              img: "/images/unit_templar.png"
            },
            {
              permno: [""],
              name: "펫",
              name_eng: "Pet",
              link: "/pet",
              img: "/images/pet_squirrel.png"
            },
            {
              permno: [""],
              name: "유용한 정보",
              name_eng: "Useful Info",
              link: "/info",
              img: "/images/abyssal_compendium.png"
            },
            // {
            //   permno: [""],
            //   name: "직업&특성2",
            //   link: "/class2",
            //   img: "/images/unit_templar.png"
            // },
          ]
        },
        {
          pagegroup_no: 2,
          name: "Community",
          active: true,
          list: [
            {
              permno: [""],
              name: "제보&건의",
              name_eng: "Report&Suggest",
              link: "/report",
              img: "/images/icon_effect_silence.png",
              size: 64,
            },
            {
              permno: [""],
              name: "조합 공유",
              name_eng: "Team Sharing",
              link: "/mapdeck",
              img: "/images/bottom_nav_adventurers.png",
              size: 64,
            },
          ]
        },
        {
          pagegroup_no: 3,
          name: "Note",
          active: true,
          list: [
            {
              permno: [""],
              name: "개선내역",
              name_eng: "Notice",
              link: "/notice",
              img: "/images/icon_effect_taunt.png",
              size: 64,
            },
          ]
        },
      ],
      myperm: [], // 내 권한
      main_notice_list: [],
      note_new: false,
    };
  },
  components: {
    Header,
  },
  computed: {
    currentLang() {
      return this.$store.state.lan; // 또는 원하는 방식으로 현재 언어 상태 가져오기
    }
  },
  methods: {
    getLocalizedName(item, key) {
      const lang = this.$store.state.lan;
      const engKey = `${key}_eng`; // 예: type_name -> type_name_eng

      return lang === 'eng' && item[engKey] ? item[engKey] : item[key];
    },
    getTrans(type) {
      const translation = config.trans[type];
      if (translation) {
        return translation[this.currentLang] || translation['kor']; // 기본값으로 'kor' 선택
      }
      return type; // 기본값으로 type을 반환 (해당 번역이 없을 경우)
    },
    getMainNoticeContent(l) {
      return l.content;
    },
    getLocalizedPageName(page) {
      return this.$store.state.lan === 'eng' && page.name_eng ? page.name_eng : page.name;
    },
    get_notice_list() {
      axios({
        url: config.apiurl + "/main/notice/list",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        method: "POST",
        data: {
          token: this.$store.state.token,
        },
      }).then((response) => {
        let d = response.data;
        // console.log(d)
        if (d.result == 1) {
          this.main_notice_list = d.main_notice_list;
          this.note_new = d.note_new;
        }
      }).catch(function (error) {
        alert("오류가 발생했습니다...(get_notice_list)");
        console.log("에러야!");
        console.log(error);
      });
    },
    check_mypage() {
      axios({
        url: config.apiurl + "?part=util&mode=check_mypage",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        method: "POST",
        data: {
          token: this.$store.state.token,
        },
      }).then((response) => {
        let d = response.data;
        if (d.superAdmin == 1) {
          this.set_admin();
        } else {
          this.myperm = d.perm_list;
          this.set_page();
        }
      }).catch(function (error) {
        alert("오류가 발생했습니다...(1)");
        console.log("에러야!");
        console.log(error);
      });
    },
    check_perm(permno) {
      let check = permno.filter((x) => this.myperm.includes(x));
      if (check.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    set_admin() {
      let admin_page = [];
      this.pages.forEach((pagegroup) => {
        pagegroup.list.forEach((page) => {
          page.permno.forEach((permno) => {
            admin_page.push(permno);
          });
        });
      });
      this.myperm = admin_page;
    },
    set_page() { // 내 권한이 포함되지 않은 영역은 비활성화
      this.pages.forEach((pagegroup) => {
        let check = false;
        pagegroup.list.forEach((page) => {
          page.permno.forEach((permno) => {
            if (this.myperm.indexOf(permno) !== -1) {
              check = true;
            }
          });
        });

        pagegroup.active = check;
      });
    },

    toggle_pagegroup(no) {
      this.pages.forEach(pagegroup => {
        if (pagegroup.pagegroup_no == no) {
          pagegroup.active = !pagegroup.active;
        }
      });
    }
  },
  mounted: function () {
    // this.check_mypage();
    this.get_notice_list();
    common.reset_page_option(this);
  },
};
</script>

<style>
.note_new {
  color: red;
  font-weight: 500;
  font-size: 15px;
  margin-right: 10px;
}
</style>